import { render, staticRenderFns } from "./Back.vue?vue&type=template&id=6d5e73e3&scoped=true&"
import script from "./Back.vue?vue&type=script&lang=ts&"
export * from "./Back.vue?vue&type=script&lang=ts&"
import style0 from "./Back.vue?vue&type=style&index=0&id=6d5e73e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5e73e3",
  null
  
)

export default component.exports